import { h } from 'preact'
import IconCogs from "./icons/IconCogs"

const WidgetError = ({ message }) => (
    <div class="fxs_widget-error">
        <IconCogs />
        <p>
            {message}
        </p>

    </div>
)

export default WidgetError